export default "__VITE_ASSET__EhfzeT4___"